import {
    AggregationModel,
    AggregationResponse,
    ApiResultFailed,
    AuditWorkplaceModel,
    GrouppedQueryModel,
    HttpResponse,
    Operation,
    RequestParams,
} from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import { CrudDataQuery, CrudService } from '@/libs/core/+state/models/crud-service';
import { CrudEnumerableResponse, CrudResponse } from '../core/+state/models/crud-response';

export class AuditWorkplacesDataService implements CrudService<AuditWorkplaceModel, AuditWorkplaceModel> {
    getAll(query: CrudDataQuery<AuditWorkplaceModel>): Promise<CrudEnumerableResponse<AuditWorkplaceModel>> {
        return ApiService.api.getAuditWorkplaceBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<AuditWorkplaceModel>): Promise<CrudEnumerableResponse<AuditWorkplaceModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<AuditWorkplaceModel>> {
        return ApiService.api.getAuditWorkplaceById(id, params);
    }

    create(item: AuditWorkplaceModel, params?: RequestParams): Promise<CrudResponse<AuditWorkplaceModel>> {
        return ApiService.api.insertAuditWorkplace(item, params);
    }

    update(item: AuditWorkplaceModel, params?: RequestParams): Promise<AuditWorkplaceModel> {
        return ApiService.api.updateAuditWorkplace(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<AuditWorkplaceModel> {
        return ApiService.api.patchAuditWorkplace(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<AuditWorkplaceModel>): Promise<CrudEnumerableResponse<AuditWorkplaceModel>> {
        return ApiService.api.deleteAuditWorkplaces(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationAuditWorkplace(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<AuditWorkplaceModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: AuditWorkplaceModel, params?: RequestParams): Promise<CrudResponse<AuditWorkplaceModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getAuditWorkplaceGroupped(query, params);
    }
}
